import { REQUEST_ATTEMPT_DEFAULT as Ne } from "../common/constants.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
const h = {
  H: {
    Ze: "data",
    vi: "content_cards/sync",
    wo: "feature_flags/sync",
    On: "template",
    G: "banners/sync",
  },
  bc: (t) => (null == t ? void 0 : t.dt(s.ft.lE)),
  Am: (t) => (null == t ? void 0 : t.dt(s.ft._E)),
  Rm: (t, e) => {
    null == t || t.bt(s.ft.lE, e);
  },
  qm: (t, e) => {
    null == t || t.bt(s.ft._E, e);
  },
  Pl: (t, e) => {
    if (!t || !e) return -1;
    const s = h.bc(t);
    if (null == s) return -1;
    const n = s[e];
    return null == n || isNaN(n) ? -1 : n;
  },
  Ul: (t, e) => {
    let s = Ne;
    if (!t || !e) return s;
    const n = h.Am(t);
    return null == n ? s : ((s = n[e]), null == s || isNaN(s) ? Ne : s);
  },
  K: (t, e, s) => {
    if (!t || !e) return;
    let n = h.bc(t);
    null == n && (n = {}), (n[e] = s), h.Rm(t, n);
  },
  xl: (t, e, s) => {
    if (!t || !e) return;
    let n = h.Am(t);
    null == n && (n = {}), (n[e] = s), h.qm(t, n);
  },
  fi: (t, e) => {
    t && e && h.xl(t, e, Ne);
  },
  Zl: (t, e) => {
    if (!t || !e) return;
    const s = h.Ul(t, e);
    h.xl(t, e, s + 1);
  },
};
export default h;
